document.addEventListener('DOMContentLoaded', function() {
  // Funciones para actualizar la interfaz del carrito
  const cartUpdater = {
    // Cache de datos del carrito
    cartCache: null,
    lastUpdateTime: 0,
    
    // Función para actualizar todos los contadores y totales del carrito
    updateAllCartUI: function(forceRefresh = false) {
      // Si forzamos refresh o no hay una actualización reciente (menos de 200ms)
      if (forceRefresh || !this.lastUpdateTime || Date.now() - this.lastUpdateTime > 200) {
        // Marcar el tiempo de la última actualización
        this.lastUpdateTime = Date.now();
        
        // Añadir parámetro de tiempo para evitar caché
        fetch('/cart.js?t=' + Date.now(), {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          }
        })
        .then(response => response.json())
        .then(cart => {
          // Guardar el carrito en caché
          this.cartCache = cart;
          
          // Actualizar contadores de artículos
          this.updateCartCounters(cart.item_count);
          
          // Actualizar totales
          this.updateCartTotals(cart.total_price);
          
          // Disparar eventos para la barra de envío gratis
          this.triggerShippingBarEvents();
        })
        .catch(error => console.error('Error actualizando carrito:', error));
      } else if (this.cartCache) {
        // Usar caché si la hay y no pasó mucho tiempo
        this.updateCartCounters(this.cartCache.item_count);
        this.updateCartTotals(this.cartCache.total_price);
      }
    },
    
    // Actualizar todos los contadores del carrito
    updateCartCounters: function(itemCount) {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(element => {
        element.textContent = itemCount;
      });
    },
    
    // Actualizar totales del carrito 
    updateCartTotals: function(totalPrice) {
      const totalElements = document.querySelectorAll('.totals__subtotal-value');
      const formattedPrice = this.formatPrice(totalPrice);
      
      totalElements.forEach(element => {
        element.innerHTML = formattedPrice;
      });
    },
    
    // Formatear precio según el formato de Shopify
    formatPrice: function(cents) {
      // Usar el formateo de precios de Shopify si está disponible
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      
      // Formateo básico si no está disponible Shopify.formatMoney
      const dollars = cents / 100;
      return '$' + dollars.toFixed(2);
    },
    
    // Disparar eventos para la barra de envío gratis
    triggerShippingBarEvents: function() {
      const cartChangedEvent = new CustomEvent('afterCartChanged');
      const updateQuantityEvent = new CustomEvent('afterUpdateQuantity');
      
      document.dispatchEvent(cartChangedEvent);
      document.dispatchEvent(updateQuantityEvent);
    },
    
    // Guardar carrito en sessionStorage para mejorar la navegación 
    // (versión optimizada que no bloquea)
    saveCartToSession: function() {
      if (this.cartCache) {
        // Usar setTimeout para no bloquear la navegación
        setTimeout(() => {
          try {
            sessionStorage.setItem('lastCartData', JSON.stringify(this.cartCache));
            sessionStorage.setItem('lastCartTime', Date.now().toString());
          } catch (e) {
            console.error('Error guardando carrito en session:', e);
          }
        }, 0);
      }
    },
    
    // Cargar carrito desde sessionStorage
    loadCartFromSession: function() {
      try {
        const lastCartData = sessionStorage.getItem('lastCartData');
        const lastCartTime = parseInt(sessionStorage.getItem('lastCartTime') || '0');
        
        // Si hay datos y no son muy antiguos (menos de 5 segundos)
        if (lastCartData && Date.now() - lastCartTime < 5000) {
          this.cartCache = JSON.parse(lastCartData);
          this.lastUpdateTime = lastCartTime;
          
          // Actualizar UI con datos de la sesión
          this.updateCartCounters(this.cartCache.item_count);
          this.updateCartTotals(this.cartCache.total_price);
          
          return true;
        }
      } catch (e) {
        console.error('Error cargando carrito desde session:', e);
      }
      
      return false;
    }
  };
  
  // Cargar datos de sesión al inicio
  const sessionLoaded = cartUpdater.loadCartFromSession();
  
  // Si no se pudo cargar desde la sesión, forzar actualización
  if (!sessionLoaded) {
    cartUpdater.updateAllCartUI(true);
  }
  
  // Fix para el botón View Cart - NO BLOQUEAR LA NAVEGACIÓN
  const viewCartButton = document.getElementById('CartDrawer-ViewCart');
  if (viewCartButton) {
    // No añadir event listeners que puedan retrasar la navegación
    // Solo registrar el estado actual del carrito en background
    cartUpdater.saveCartToSession();
  }
  
  // Manejo de eventos para el carrito principal
  function setupMainCartListeners() {
    const mainCart = document.getElementById('main-cart');
    if (!mainCart) return;
    
    // Escuchar cambios en las cantidades
    mainCart.addEventListener('change', function(event) {
      if (event.target.classList.contains('quantity__input')) {
        // Agregar clase de carga al elemento del carrito
        const cartItem = event.target.closest('.cart-item');
        if (cartItem) {
          const loadingOverlay = cartItem.querySelector('.loading-overlay');
          if (loadingOverlay) {
            loadingOverlay.classList.remove('hidden');
          }
        }
        
        // Actualizar después de un corto retraso
        setTimeout(() => {
          cartUpdater.updateAllCartUI(true);
          
          // Ocultar overlay de carga después de la actualización
          if (cartItem && loadingOverlay) {
            setTimeout(() => {
              loadingOverlay.classList.add('hidden');
            }, 300);
          }
        }, 300);
      }
    });
    
    // Escuchar clics en botones de eliminar o ajustar cantidad
    mainCart.addEventListener('click', function(event) {
      const isRemoveButton = event.target.closest('cart-remove-button');
      const isQuantityButton = event.target.closest('.quantity__button');
      
      if (isRemoveButton || isQuantityButton) {
        // Esperar a que el carrito se actualice y luego actualizar la UI
        setTimeout(() => {
          cartUpdater.updateAllCartUI(true);
        }, 300);
      }
    });
  }
  
  // Inicializar rastreo del estado del cart drawer
  function setupCartDrawerListeners() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    let drawerWasOpen = false;
    
    // Observador para detectar apertura/cierre del drawer
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'open') {
          const isOpenNow = cartDrawer.hasAttribute('open');
          
          // Si se acaba de abrir
          if (isOpenNow && !drawerWasOpen) {
            cartUpdater.updateAllCartUI();
          }
          
          // Si se acaba de cerrar
          if (drawerWasOpen && !isOpenNow) {
            // Solo actualizar, no guardar en session (podría retrasar)
            cartUpdater.updateAllCartUI(true);
          }
          
          drawerWasOpen = isOpenNow;
        }
      }
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Escuchar eventos de cambio dentro del drawer
    cartDrawer.addEventListener('change', function(event) {
      if (event.target.classList.contains('quantity__input')) {
        setTimeout(() => cartUpdater.updateAllCartUI(true), 300);
      }
    });
    
    // Escuchar clics en botones de eliminar o ajustar cantidad
    cartDrawer.addEventListener('click', function(event) {
      const isRemoveButton = event.target.closest('cart-remove-button');
      const isQuantityButton = event.target.closest('.quantity__button');
      
      if (isRemoveButton || isQuantityButton) {
        setTimeout(() => cartUpdater.updateAllCartUI(true), 300);
      }
    });
  }
  
  // Interceptar todas las solicitudes fetch relacionadas con el carrito
  // VERSIÓN OPTIMIZADA: No bloquear navegación
  function setupFetchInterceptor() {
    const originalFetch = window.fetch;
    window.fetch = function() {
      const fetchPromise = originalFetch.apply(this, arguments);
      const url = arguments[0].toString();
      
      // No interceptar si estamos en medio de una navegación
      const isNavigating = document.visibilityState === 'hidden';
      
      // Detectar si es una operación del carrito
      if (!isNavigating && 
          (url.includes('/cart/') || url.includes('/cart.js') || 
           url.includes('/cart/add') || url.includes('/cart/change')) &&
          !url.includes('cart_url')) {
        
        fetchPromise.then(function() {
          // Esperar a que la operación del carrito termine y actualizar la UI
          setTimeout(() => cartUpdater.updateAllCartUI(true), 300);
        });
      }
      
      return fetchPromise;
    };
  }
  
  // Inicializar todo
  function init() {
    // Configurar listeners
    setupMainCartListeners();
    setupCartDrawerListeners();
    setupFetchInterceptor();
    
    // Escuchar botones de añadir al carrito en toda la página
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => cartUpdater.updateAllCartUI(true), 500);
      });
    });
  }
  
  // Iniciar
  init();
});